import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { Box, Button, ListItem, OrderedList, Text } from "@chakra-ui/react";
import React, { useState } from "react";

export default function PaymentATM() {
  const [open, setOpen] = useState(false);
  return (
    <Box>
      <Button w="full" variant="ghost" onClick={() => setOpen(!open)}>
        <Box w="full" textAlign="left">
          Pembayaran Dari ATM Bersama
        </Box>
        {open ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </Button>
      {open && (
        <OrderedList px="5" spacing={2}>
          <ListItem>Pilih Bahasa</ListItem>
          <ListItem>Masukkan PIN</ListItem>
          <ListItem>
            Pilih <b>“Transaksi Lainnya”</b>
          </ListItem>
          <ListItem>
            Pilih <b>“Transfer”</b>
          </ListItem>
          <ListItem>
            Pilih <b>“Ke Rekening Bank Lain”</b>
          </ListItem>
          <ListItem>
            Masukkan nomor rekening tujuan <b> (No Virtual Account)</b>, lalu
            tekan <b>“Benar/Lanjut”</b>
          </ListItem>
          <ListItem>
            Input <b>nominal</b> yang ingin ditransfer sesuai <b>tagihan</b>{" "}
            yang ingin dibayar, lalu tekan <b>“Benar/Lanjut”</b>
          </ListItem>
          <ListItem>
            Silakan isi atau kosongkan nomor referensi transfer kemudian tekan
            <b>“Benar”</b>
          </ListItem>
          <ListItem>
            Muncul Layar Konfirmasi Transfer yang berisi nomor rekening tujuan
            bank beserta jumlah yang dibayar
          </ListItem>
          <ListItem>
            Jika sudah benar, Tekan <b>“Benar”</b>.
          </ListItem>
          <ListItem>Selesai</ListItem>
          <Text>
            Note : tata cara tiap bank mungkin ada sedikit berbeda namun secara
            gambaran umum sama seperti penjelasan diatas.
          </Text>
        </OrderedList>
      )}
    </Box>
  );
}
